import { commonMonitor, recordMonitor } from '@/api/url.js' // 服务端监测记录，

function commonMonitorFun (params) {
  commonMonitor(params).then(res => {})
}
let resultObj = null
let fromSever = true
// 一进入页面就会调用的方法，判断是否是引入服务器js文件
export function buryCode (channel, append) {
  if (window.addCode && window.addCode.codeType) {
    console.log('采用数据库里的数据进行埋码->参数', window.addCode);
    // 整理成方法
    resultObj = window.getChannelResult2(window.addCode);
    // 执行加载
    if (resultObj && resultObj.jsUrl && typeof resultObj.jsUrl === "function") {
      try {
        resultObj.jsUrl()
      } catch (error) {
        console.log('采取数据库参数埋码，执行jsUrl方法报错', error);
      }
    }
  } else {
    console.log('采用channel.js数据进行埋码');
    resultObj = window.getChannelResult(channel)
    if (resultObj) {
      fromSever = false
      if (resultObj.jsUrl !== 'function') {
        let script = document.createElement('script')
        script.type = 'module'
        script.src = resultObj.jsUrl
        document.getElementsByTagName(append)[0].appendChild(script)
      }
    } else {
      console.log('channel.js里没有找到渠道');
    }
  }
}
// 提交时调用的方法
export function buryCodeFun (channel) {
  if (resultObj && resultObj.func) {
    if (resultObj.jsUrl == 'function') { // 如果是接口的情况下，那就直接调用后端公共接口
      console.log(resultObj.func())
      commonMonitorFun(resultObj.func())
    } else { // 调用js方法
      resultObj.func(channel)
    }
    if (fromSever) { // 服务器端生成函数 统一在这里调用monitor
      window.monitor(channel)
    }
  }

  if(window.handleApiCallback){
    window.handleApiCallback()
  }
}
// 后端监听
window.monitor = function (channel) {
  recordMonitor({
    dataInfo: channel
  }).then(res => {
    console.log(res)
  }).catch(err => {
    console.log(err)
  })
}



// WEBPACK FOOTER //
// ./src/public/buryCode.js